'use strict';

var _resource_manager = require('./resource_manager');

var _resource_manager2 = _interopRequireDefault(_resource_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = { ResourceManager: _resource_manager2.default };


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/@rosetta+resource-manager@file+@rosetta+resource-manager/~/@rosetta/resource-manager/dist/index.js
// module id = 323
// module chunks = 0